var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.event
    ? _c("div", { staticClass: "station-event" }, [
        _c("div", { staticClass: "d-flex align-baseline" }, [
          _c("div", { staticClass: "headline font-weight-bold mr-4" }, [
            _vm.event.installed_at && _vm.event.collected_at
              ? _c("div", { staticClass: "d-flex align-center" }, [
                  _c("div", { staticClass: "mr-8" }, [
                    _vm._v(_vm._s(_vm.event.trap_no)),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.formatDate(_vm.event.installed_at))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mx-2" }, [_vm._v("~")]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.formatDate(_vm.event.collected_at))),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "headline font-weight-bold flex" }, [
            _vm.event.month
              ? _c("div", { staticClass: "d-flex align-center" }, [
                  _c(
                    "div",
                    { staticClass: "station-event__content align-center px-2" },
                    [_vm._v(_vm._s(_vm.formatMonth(_vm.event.month)))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-2" }, [
                    _vm._v(_vm._s(_vm.$t("month"))),
                  ]),
                  _vm._v(" "),
                  _vm.isNotRecentEvent
                    ? _c(
                        "div",
                        { staticClass: "station-event__edit-button" },
                        [
                          _vm.downloadOptions.length > 0
                            ? _c(
                                "v-menu",
                                {
                                  attrs: { "offset-y": "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  { attrs: { text: "" } },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("fa-download"),
                                                ]),
                                                _vm._v(" "),
                                                _c("small", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("menu.download")
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    712515933
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    _vm._l(
                                      _vm.downloadOptions,
                                      function (downloadOption) {
                                        return _c(
                                          "v-list-item",
                                          {
                                            key: downloadOption.type,
                                            on: {
                                              click: function ($event) {
                                                return _vm.download(
                                                  downloadOption.type
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(downloadOption.label) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-btn",
                                {
                                  attrs: { text: "" },
                                  on: { click: _vm.download },
                                },
                                [
                                  _c("v-icon", [_vm._v("fa-download")]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(_vm._s(_vm.$t("menu.download"))),
                                  ]),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          !_vm.event.updating
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    text: "",
                                    disabled: !_vm.hasDetections,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      _vm.editing = true
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [_vm._v("fa-edit")]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(_vm._s(_vm.$t("menu.edit"))),
                                  ]),
                                ],
                                1
                              )
                            : _vm.showTimeoutMenu
                            ? _c(
                                "v-menu",
                                {
                                  attrs: { "offset-y": "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function (ref) {
                                                        var tooltipOn = ref.on
                                                        var tooltipAttrs =
                                                          ref.attrs
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    text: "",
                                                                    "data-testid":
                                                                      "edit-timeout-warning",
                                                                  },
                                                                },
                                                                "v-btn",
                                                                Object.assign(
                                                                  {},
                                                                  attrs,
                                                                  tooltipAttrs
                                                                ),
                                                                false
                                                              ),
                                                              Object.assign(
                                                                {},
                                                                on,
                                                                tooltipOn
                                                              )
                                                            ),
                                                            [
                                                              _c(
                                                                "v-badge",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "warning",
                                                                    overlap: "",
                                                                    bottom: "",
                                                                    icon: "mdi-alert",
                                                                  },
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "fa-edit"
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c("small", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "menu.edit"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "msg.timeout.detail"
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1753450921
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-item",
                                        {
                                          attrs: {
                                            disabled: !_vm.hasDetections,
                                            "data-testid": "retry",
                                          },
                                          on: { click: _vm.retry },
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.$t("menu.retry"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item",
                                        {
                                          attrs: {
                                            "data-testid": "edit-again",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.editing = true
                                            },
                                          },
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.$t("menu.edit_again"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item",
                                        {
                                          attrs: { "data-testid": "dismiss" },
                                          on: { click: _vm.confirmDismiss },
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.$t("menu.dismiss"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-btn",
                                { attrs: { text: "", disabled: "" } },
                                [
                                  _c("v-icon", [_vm._v("fa-refresh")]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(_vm._s(_vm.$t("menu.updating"))),
                                  ]),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          !_vm.event.updating
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { text: "" },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.$emit("deleteEvent")
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [_vm._v("fa-trash")]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(_vm._s(_vm.$t("menu.delete"))),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "pb-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.formatDateTime(_vm.event.upload_time)) +
                "\n    "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "div",
              [
                _vm.event.processing
                  ? _c("station-event-processing")
                  : _c("div", { staticClass: "d-flex flex-nowrap" }, [
                      _c(
                        "div",
                        { staticClass: "station-event__main" },
                        [
                          _c(
                            "v-carousel",
                            {
                              key: _vm.event.id,
                              attrs: {
                                "hide-delimiters": "",
                                touchless: "",
                                height: "auto",
                              },
                              model: {
                                value: _vm.selectedIndex,
                                callback: function ($$v) {
                                  _vm.selectedIndex = $$v
                                },
                                expression: "selectedIndex",
                              },
                            },
                            _vm._l(_vm.photos, function (photo) {
                              return _c(
                                "v-carousel-item",
                                { key: photo.id, attrs: { eager: "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-center w-100",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "station-event__drawer",
                                        },
                                        [
                                          _c("picked-insects-draw", {
                                            ref: "drawers",
                                            refInFor: true,
                                            attrs: {
                                              imageSrc:
                                                _vm._f("imageSrc")(photo),
                                              detectionsUrl:
                                                _vm.makeDetectionsUrl(photo),
                                              pickedDetectionType:
                                                _vm.pickedDetectionType,
                                              originalImageWidth:
                                                _vm.imageDimensions.width,
                                              originalImageHeight:
                                                _vm.imageDimensions.height,
                                              "locomotion-scope":
                                                _vm.insectLocomotionScope,
                                              hideCanvas: _vm.viewOriginal,
                                            },
                                            on: { save: _vm.save },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "station-event__selector" },
                            [
                              _vm.photos.length <=
                              _vm.MAX_PHOTOS_FOR_DOT_SELECTOR
                                ? _c("dot-selector", {
                                    attrs: {
                                      value: _vm.selectedIndex,
                                      size: _vm.photos.length,
                                    },
                                    on: { change: _vm.selectPhoto },
                                  })
                                : _c("photo-page-selector", {
                                    attrs: {
                                      value: _vm.selectedIndex,
                                      max: _vm.photos.length - 1,
                                    },
                                    on: { change: _vm.selectPhoto },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "station-event__side" }, [
                        _c(
                          "div",
                          { staticClass: "station-event__table-area" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-center justify-end px-1",
                              },
                              [
                                _c("v-checkbox", {
                                  staticClass: "ma-0 pa-0 flex-grow-1",
                                  staticStyle: { "flex-grow": "1" },
                                  attrs: {
                                    label: _vm.$t("original"),
                                    color: "primary",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.viewOriginal,
                                    callback: function ($$v) {
                                      _vm.viewOriginal = $$v
                                    },
                                    expression: "viewOriginal",
                                  },
                                }),
                                _vm._v(" "),
                                _c("chart-type-select", {
                                  model: {
                                    value: _vm.chartType,
                                    callback: function ($$v) {
                                      _vm.chartType = $$v
                                    },
                                    expression: "chartType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.chartTypeIs("table")
                              ? _c("insect-count-table", {
                                  staticClass: "station-event__result-table",
                                  attrs: {
                                    insectCounts: _vm.event.insect_counts,
                                    "locomotion-scope":
                                      _vm.insectLocomotionScope,
                                    showRadiobutton: !_vm.event.updating,
                                    pickedDetectionType:
                                      _vm.pickedDetectionType,
                                    showFocusButton: "",
                                  },
                                  on: {
                                    "update:pickedDetectionType": function (
                                      $event
                                    ) {
                                      _vm.pickedDetectionType = $event
                                    },
                                    "update:picked-detection-type": function (
                                      $event
                                    ) {
                                      _vm.pickedDetectionType = $event
                                    },
                                    "click:focus": _vm.handleFocus,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.chartTypeIs("bar")
                              ? _c("insect-count-by-type-bar-chart", {
                                  attrs: {
                                    insectCounts: _vm.event.insect_counts,
                                    "locomotion-scope":
                                      _vm.insectLocomotionScope,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.chartTypeIs("pie")
                              ? _c("top-5-insect-types-pie-chart", {
                                  attrs: {
                                    insectCounts: _vm.event.insect_counts,
                                    "locomotion-scope":
                                      _vm.insectLocomotionScope,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "section",
                          {
                            staticClass: "pb-3 station-event__metadata",
                            attrs: { "data-testid": "Metadata" },
                          },
                          [
                            _c("ul", [
                              _vm.event.ip_address
                                ? _c("li", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("ip_address")) +
                                        ": " +
                                        _vm._s(_vm.event.ip_address) +
                                        "\n              "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.event.firmware_version
                                ? _c("li", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("firmware_version")) +
                                        ": " +
                                        _vm._s(_vm.event.firmware_version) +
                                        "\n              "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.event.serial_no
                                ? _c("li", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("serial_no")) +
                                        ": " +
                                        _vm._s(_vm.event.serial_no) +
                                        "\n              "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isNotRecentEvent
              ? _c("insect-detections-editor", {
                  attrs: {
                    event: _vm.event,
                    "locomotion-scope": _vm.insectLocomotionScope,
                    imageSrc: _vm.current.display,
                    detectionsUrl: _vm.makeDetectionsUrl(_vm.current),
                    originalImageWidth: _vm.imageDimensions.width,
                    originalImageHeight: _vm.imageDimensions.height,
                    canViewDetectionDetail: "",
                  },
                  on: {
                    updated: function ($event) {
                      return _vm.$emit("pollEvent")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("content-header", {
                              staticClass: "w-100",
                              attrs: {
                                title: _vm.event.stationName,
                                titleClass: "title my-1",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "icon",
                                    fn: function () {
                                      return [
                                        _c("icon", {
                                          attrs: { type: "fly_count" },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "subtitle",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "title details" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.timestamp.date)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "ml-3" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(_vm.timestamp.time) +
                                                    "\n              "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                211931507
                              ),
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3551447713
                  ),
                  model: {
                    value: _vm.editing,
                    callback: function ($$v) {
                      _vm.editing = $$v
                    },
                    expression: "editing",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("ConfirmDialog", {
              attrs: {
                message: _vm.$t("msg.dismiss.confirm"),
                "data-testid": "dismiss-confirm-dialog",
              },
              on: { yes: _vm.executeDismiss },
              model: {
                value: _vm.dismissConfirmOpen,
                callback: function ($$v) {
                  _vm.dismissConfirmOpen = $$v
                },
                expression: "dismissConfirmOpen",
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }